import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMe } from '../hooks/data.js';
import { useOnline } from './Checkliste.jsx';
import { Icon } from '../components/Icon.jsx';
import { Einstellungen } from '../verwaltung/Einstellungen.jsx';
import { Begriffe } from '../verwaltung/Begriffe.jsx';
import { Protokoll } from '../verwaltung/Protokoll.jsx';
import { Pruefung } from '../verwaltung/Pruefung.jsx';

const BEREICHE = [['einstellungen', 'Einstellungen'], ['begriffe', 'Begriffe'], ['pruefung', 'Prüfung'], ['protokoll', 'Protokoll']];

/**
 * Verwaltung der Firma (nur Firmenadmins): Einstellungen, Begriffe, Prüfung «startklar?», Protokoll. Was Geheimnis ist oder ki|partner
 * verwaltet, ist schreibgeschützt. Die API prüft die Rolle selbst – die Seite blendet sich nur aus.
 */
export function Verwaltung() {
  const me = useMe();
  const navigate = useNavigate();
  const online = useOnline();
  const [bereich, setBereich] = useState('einstellungen');
  if (me.data && !me.data.rollen?.includes('firmenadmin')) return <Navigate to="/" replace />;

  return (
    <div className="app">
      <div className="scroll">
        <div className="swrap">
          <div className="row" style={{ gap: 12 }}>
            <button className="iconbtn" aria-label="Zurück" onClick={() => navigate('/')}><Icon name="back" stroke={2.4} /></button>
            <div className="stack" style={{ gap: 0, minWidth: 0 }}>
              <span className="sub ellipsis" style={{ fontWeight: 700 }}>{me.data?.mandant?.name}</span>
              <h1 className="h1">Verwaltung</h1>
            </div>
          </div>
          <div className="segment vier" role="tablist" aria-label="Bereich">
            {BEREICHE.map(([k, titel]) => (
              <button key={k} type="button" role="tab" aria-selected={bereich === k} className={bereich === k ? 'on' : ''} onClick={() => setBereich(k)}>{titel}</button>
            ))}
          </div>
          {bereich === 'einstellungen' && <Einstellungen online={online} />}
          {bereich === 'begriffe' && <Begriffe online={online} />}
          {bereich === 'pruefung' && <Pruefung online={online} />}
          {bereich === 'protokoll' && <Protokoll />}
        </div>
      </div>
    </div>
  );
}
